export default "__VITE_ASSET__gnFK0xiD__"